export default __webpack_public_path__ + "static/media/logo-desktop.9c65ccf8.svg";